/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // ==============================================
  // GA4 Custom Event Tracking - ATC Button Clicks
  // ==============================================
  // Tracks which Add to Cart button was clicked:
  // - main_product_form: The primary ATC button on the product page
  // - sticky_bar: The sticky ATC bar that appears on scroll
  // - upsell: Upsell product buttons (cart drawer, product page)
  // - quick_add: Quick add buttons on collection grids
  // - bundle: "Add All to Cart" bundle buttons
  // Events appear in GA4 under Events > add_to_cart_click
  // with the atc_button_location parameter for segmentation
  // ==============================================
  document.addEventListener('click', function(e) {
    // Ensure gtag is available
    if (typeof gtag !== 'function') return;

    // Check for various ATC button types (order matters - most specific first)
    const stickyATC = e.target.closest('[data-sticky-atc-button]');
    const bundleATC = e.target.closest('[data-bundle-addtocart]');
    const upsellATC = e.target.closest('.product-upsell__btn');
    const quickAddATC = e.target.closest('.btn--quick[data-add-to-cart], [data-atc-trigger]');
    const mainATC = e.target.closest('.product__submit__add');

    let buttonLocation = null;

    if (stickyATC && !stickyATC.disabled) {
      buttonLocation = 'sticky_bar';
    } else if (bundleATC && !bundleATC.disabled) {
      buttonLocation = 'bundle';
    } else if (upsellATC && !upsellATC.disabled) {
      buttonLocation = 'upsell';
    } else if (quickAddATC && !quickAddATC.disabled) {
      buttonLocation = 'quick_add';
    } else if (mainATC && !mainATC.disabled) {
      buttonLocation = 'main_product_form';
    }

    if (buttonLocation) {
      gtag('event', 'add_to_cart_click', {
        send_to: 'G-7BBBBHZTF7',
        atc_button_location: buttonLocation,
        page_path: window.location.pathname
      });
    }
  });

  const ShopifyCartURLs = [
    "add",
    "add.js",
  ];

  function isShopifyCartURL(url) {
    if (!url) return false;
    const path = url.split("/").pop();
    return ShopifyCartURLs.includes(`${path}`);
  }

  const dispatchEvent = async (url, detail) => {
    if (!detail) return;
    if (detail.status === 422) {
      let cart = await fetch('/cart.js').then((res) => res.json());
      cart.items.map((item) => {
        let metreage = item.properties.Metres;
        if (metreage && item.quantity != metreage * 2) {
          item.properties.Metres = item.quantity / 2;
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: item.properties
          })
        });
        return item;
      });
    }
  }

  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== "function") return;
    const originalFetch = window.fetch;
    window.fetch = function () {
      const response = originalFetch.apply(this, arguments);
      if (isShopifyCartURL(arguments[0])) {
        response.then((res) => {
          res
            .clone()
            .json()
            .then((data) => dispatchEvent(res.url, data));
        });
      }

      return response;
    };
  }

  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      this.addEventListener("load", function () {
        if (isShopifyCartURL(url)) {
          dispatchEvent(url, this.response);
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  XHROverride();
  fetchOverride();

  let recommendedPatterns = document.querySelector('.recommended-patterns');
  if (recommendedPatterns) {
    let recommendedPatternsSlider = new themeVendor.Flickity(recommendedPatterns, {
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      prevNextButtons: true,
      cellSelector: '.rec-line',
      watchCSS: true,
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

class QuantityPicker extends HTMLElement {
  min = 1;
  increment = 1;

  constructor () {
    super();
    this.quantityMinus = this.querySelector('.quantity-picker__button--minus');
    this.quantityPlus = this.querySelector('.quantity-picker__button--plus');
    this.quantityInput = this.querySelector('.quantity-picker__quantity');
    this.formSubmit = document.querySelector('.product__form');
    this.type = this.dataset.type;

    this.quantityMinus.addEventListener('click', this.decrementQuantity.bind(this));
    this.quantityPlus.addEventListener('click', this.incrementQuantity.bind(this));

  }

  decrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) - this.increment;
    if (newValue < this.min) {
      newValue = this.min;
    } else {
      this.updateQuantity(newValue);
    } 
  }

  incrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) + this.increment;
    this.updateQuantity(newValue);
  }

  async updateQuantity (newValue) {
    this.quantityInput.value = newValue;
    this.quantityInput.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { value: newValue } }));
  }
}

customElements.define('quantity-picker', QuantityPicker);

class YardPicker extends HTMLElement {
  min = 0.5;
  increment = 0.5;

  constructor () {
    super();
    this.quantityMinus = this.querySelector('.yard-picker__button--minus');
    this.quantityPlus = this.querySelector('.yard-picker__button--plus');
    this.quantityInput = this.querySelector('.yard-picker__quantity');
    this.formSubmit = document.querySelector('.product__form');
    this.type = this.dataset.type;

    this.quantityMinus.addEventListener('click', this.decrementQuantity.bind(this));
    this.quantityPlus.addEventListener('click', this.incrementQuantity.bind(this));
    this.quantityInput.addEventListener('change', (e) => {
      this.updateQuantity(e.target.value);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    this.quantityInput.addEventListener('input', (e) => {
      this.updateQuantity(e.target.value);
    });

  }

  decrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) - this.increment;
    this.updateQuantity(newValue);
  }

  incrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) + this.increment;
    this.updateQuantity(newValue);
  }

  updateQuantityDisplay (newValue, newQuantity) {
    if (newQuantity == this.dataset.max) {
      this.quantityPlus.setAttribute('disabled', 'true');
    } else {
      this.quantityPlus.removeAttribute('disabled');
    }

    if (newValue == this.min) {
      this.quantityMinus.setAttribute('disabled', 'true');
    } else {
      this.quantityMinus.removeAttribute('disabled');
    }
  }


  async updateQuantity (newValue) {
    let newQuantity = newValue * 2;
    if (newValue < this.min) {
      newValue = this.min;
    } else if (newQuantity > this.dataset.max) {
      newValue = this.dataset.max / 2;
      newQuantity = this.dataset.max;
    } else if (newValue % this.increment !== 0) {
      newValue = Math.round(newValue / this.increment) * this.increment;
    }

    let oldValue = this.quantityInput.value;
    this.quantityInput.value = newValue;

    // Always sync hidden inputs/datasets even if visible value didn't change
    if (this.type == 'product') {
      this.formSubmit.querySelector('[name="quantity"]').value = newValue * 2;
      const metresInput = this.formSubmit.querySelector('[name="properties[Metres]"]');
      if (metresInput) metresInput.value = newValue;
    } else if (this.type == 'bundle') {
      this.querySelector('.yard-picker__quantity').dataset.quantity = newValue * 2;
      this.querySelector('.yard-picker__quantity').dataset.yards = newValue;
    } else if (oldValue != newValue) {
      let cartItem = this.closest('.cart__item');
      let cartDrawer = this.closest('.cart-drawer');
      if (!cartDrawer) {
        cartDrawer = document.querySelector('.cart__items__wrapper');
      }
      let cartCheckoutButton = document.querySelector('.cart__checkout.btn');
      cartItem.classList.add('is-loading');
      cartDrawer.classList.add('is-loading');
      cartCheckoutButton.setAttribute('disabled', 'true');
      let itemKey = cartItem.dataset.item;
      let resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newValue * 2,
          properties: {
            Metres: newValue
          }
        })
      });
      let cart = await resp.json();
      cartItem.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true, detail: { id: itemKey, quantity: newValue * 2, properties: { Metres: newValue } } }));
      if (cart.status === 422) {
        cartItem.classList.remove('is-loading');
        cartDrawer.classList.remove('is-loading');
        cartCheckoutButton.removeAttribute('disabled');
        this.quantityInput.value = oldValue;
      }
    }
  }  
}

class FullYardPicker extends HTMLElement {
  min = 1;
  increment = 1;

  constructor () {
    super();
    this.quantityMinus = this.querySelector('.full-yard-picker__button--minus');
    this.quantityPlus = this.querySelector('.full-yard-picker__button--plus');
    this.quantityInput = this.querySelector('.full-yard-picker__quantity');
    this.formSubmit = document.querySelector('.product__form');
    this.type = this.dataset.type;

    this.quantityMinus.addEventListener('click', this.decrementQuantity.bind(this));
    this.quantityPlus.addEventListener('click', this.incrementQuantity.bind(this));
    this.quantityInput.addEventListener('change', (e) => {
      this.updateQuantity(e.target.value);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    this.quantityInput.addEventListener('input', (e) => {
      this.updateQuantity(e.target.value);
    });
  }

  decrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) - this.increment;
    this.updateQuantity(newValue);
  }

  incrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) + this.increment;
    this.updateQuantity(newValue);
  }

  updateQuantityDisplay (newValue, newQuantity) {
    if (newQuantity == this.dataset.max) {
      this.quantityPlus.setAttribute('disabled', 'true');
    } else {
      this.quantityPlus.removeAttribute('disabled');
    }

    if (newValue == this.min) {
      this.quantityMinus.setAttribute('disabled', 'true');
    } else {
      this.quantityMinus.removeAttribute('disabled');
    }
  }

  async updateQuantity (newValue) {
    // Remove the multiplication by 2
    if (newValue < this.min) {
      newValue = this.min;
    } else if (newValue > this.dataset.max) {
      newValue = this.dataset.max;
    } else if (newValue % this.increment !== 0) {
      newValue = Math.round(newValue / this.increment) * this.increment;
    }

    let oldValue = this.quantityInput.value;
    this.quantityInput.value = newValue;

    // Always sync hidden inputs/datasets even if visible value didn't change
    if (this.type == 'product') {
      // Remove the multiplication by 2 here
      this.formSubmit.querySelector('[name="quantity"]').value = newValue;
      const metresInput = this.formSubmit.querySelector('[name="properties[Metres]"]');
      if (metresInput) metresInput.value = newValue;
    } else if (this.type == 'bundle') {
      // Remove the multiplication by 2 here
      this.querySelector('.full-yard-picker__quantity').dataset.quantity = newValue;
      this.querySelector('.full-yard-picker__quantity').dataset.yards = newValue;
    } else if (oldValue != newValue) {
      let cartItem = this.closest('.cart__item');
      let cartDrawer = this.closest('.cart-drawer');
      if (!cartDrawer) {
        cartDrawer = document.querySelector('.cart__items__wrapper');
      }
      let cartCheckoutButton = document.querySelector('.cart__checkout.btn');
      cartItem.classList.add('is-loading');
      cartDrawer.classList.add('is-loading');
      cartCheckoutButton.setAttribute('disabled', 'true');
      let itemKey = cartItem.dataset.item;
      let resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newValue, // Remove the multiplication by 2 here
          properties: {
            Metres: newValue
          }
        })
      });
      let cart = await resp.json();
      cartItem.dispatchEvent(new CustomEvent('theme:cart:update', { 
        bubbles: true, 
        detail: { 
          id: itemKey, 
          quantity: newValue, // Remove the multiplication by 2 here
          properties: { Metres: newValue } 
        } 
      }));
      if (cart.status === 422) {
        cartItem.classList.remove('is-loading');
        cartDrawer.classList.remove('is-loading');
        cartCheckoutButton.removeAttribute('disabled');
        this.quantityInput.value = oldValue;
      }
    }
  }
}

class QuarterYardPicker extends HTMLElement {
  min = 0.25;
  increment = 0.25;

  constructor () {
    super();
    this.quantityMinus = this.querySelector('.quarter-yard-picker__button--minus');
    this.quantityPlus = this.querySelector('.quarter-yard-picker__button--plus');
    this.quantityInput = this.querySelector('.quarter-yard-picker__quantity');
    this.formSubmit = document.querySelector('.product__form');
    this.type = this.dataset.type;

    this.quantityMinus.addEventListener('click', this.decrementQuantity.bind(this));
    this.quantityPlus.addEventListener('click', this.incrementQuantity.bind(this));
    this.quantityInput.addEventListener('change', (e) => {
      this.updateQuantity(e.target.value);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    this.quantityInput.addEventListener('input', (e) => {
      this.updateQuantity(e.target.value);
    });

  }

  decrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) - this.increment;
    this.updateQuantity(newValue);
  }

  incrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) + this.increment;
    this.updateQuantity(newValue);
  }

  updateQuantityDisplay (newValue, newQuantity) {
    if (newQuantity == this.dataset.max) {
      this.quantityPlus.setAttribute('disabled', 'true');
    } else {
      this.quantityPlus.removeAttribute('disabled');
    }

    if (newValue == this.min) {
      this.quantityMinus.setAttribute('disabled', 'true');
    } else {
      this.quantityMinus.removeAttribute('disabled');
    }
  }


  async updateQuantity (newValue) {
    let newQuantity = newValue * 4;  // Convert quarter yards to units
    if (newValue < this.min) {
      newValue = this.min;
    } else if (newQuantity > this.dataset.max) {
      newValue = this.dataset.max / 4;  // Convert max units back to quarter yards
      newQuantity = this.dataset.max;
    } else if (newValue % this.increment !== 0) {
      newValue = Math.round(newValue / this.increment) * this.increment;
    }
  
    let oldValue = this.quantityInput.value;
    this.quantityInput.value = newValue;

    // Always sync hidden inputs/datasets even if visible value didn't change
    if (this.type == 'product') {
      this.formSubmit.querySelector('[name="quantity"]').value = newValue * 4;
      const metresInput = this.formSubmit.querySelector('[name="properties[Metres]"]');
      if (metresInput) metresInput.value = newValue;
    } else if (this.type == 'bundle') {
      this.querySelector('.quarter-yard-picker__quantity').dataset.quantity = newValue * 4;
      this.querySelector('.quarter-yard-picker__quantity').dataset.yards = newValue;
    } else if (oldValue != newValue) {
      let cartItem = this.closest('.cart__item');
      let cartDrawer = this.closest('.cart-drawer');
      if (!cartDrawer) {
        cartDrawer = document.querySelector('.cart__items__wrapper');
      }
      let cartCheckoutButton = document.querySelector('.cart__checkout.btn');
      cartItem.classList.add('is-loading');
      cartDrawer.classList.add('is-loading');
      cartCheckoutButton.setAttribute('disabled', 'true');
      let itemKey = cartItem.dataset.item;
      let resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newValue * 4,  // Use quarter yard multiplication
          properties: {
            Metres: newValue
          }
        })
      });
      let cart = await resp.json();
      cartItem.dispatchEvent(new CustomEvent('theme:cart:update', { 
        bubbles: true, 
        detail: { 
          id: itemKey, 
          quantity: newValue * 4,  // Use quarter yard multiplication
          properties: { Metres: newValue } 
        } 
      }));
      if (cart.status === 422) {
        cartItem.classList.remove('is-loading');
        cartDrawer.classList.remove('is-loading');
        cartCheckoutButton.removeAttribute('disabled');
        this.quantityInput.value = oldValue;
      }
    }
  }
}

customElements.define('yard-picker', YardPicker);
customElements.define('full-yard-picker', FullYardPicker);
customElements.define('quarter-yard-picker', QuarterYardPicker);

function validateCartQuantity(item) {
  const metres = item.properties?.Metres;
  if (!metres) return true;

  // Different multipliers based on product type
  const multiplier = item.product_type === 'quarter-yard' ? 4 : 2;
  const expectedQuantity = metres * multiplier;
  
  return item.quantity === expectedQuantity;
}

async function updateCart(item, newQuantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: newQuantity,
        properties: {
          Metres: newQuantity / (item.product_type === 'quarter-yard' ? 4 : 2)
        }
      })
    });
    
    if (!response.ok) {
      console.error('Cart update failed:', response);
      // Revert UI changes
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Cart update error:', error);
    return false;
  }
}

// French form translation functionality
(function() {
  function translateFormToFrench() {
    // console.log('French translation script starting...');
    // console.log('Current URL:', window.location.href);
    
    // Only run if URL contains '/fr'
    if (!window.location.href.includes('/fr')) {
      // console.log('URL does not contain /fr, skipping translation');
      return;
    }
    
    // console.log('URL contains /fr, proceeding with translation');
    
    // French translations for form labels
    const translations = {
      'First name': 'Prénom',
      'Last name': 'Nom',
      'Email': 'Courriel',
      'Legal company name': 'Nom légal de l\'entreprise',
      'Operating As': 'Opérant sous le nom de',
      'Company contact title': 'Titre de la personne contact',
      'Company / attention': 'Entreprise / à l\'attention de',
      'Address': 'Adresse',
      'Apartment, suite, etc': 'Appartement, suite, etc',
      'City': 'Ville',
      'Province': 'Province',
      'Postal code': 'Code postal',
      'Phone': 'Téléphone',
      'Company address': 'Adresse de l\'entreprise',
      'Company billing address': 'Adresse de facturation de l\'entreprise',
      'Same as shipping address': 'Identique à l\'adresse de livraison',
      'Submit': 'Soumettre'
    };
    
    function translateFormElements() {
      // console.log('Running translateFormElements...');
      
      // Translate input labels
      const labels = document.querySelectorAll('label[class*="_formInputFieldLabel"]');
      // console.log('Found', labels.length, 'input labels');
      labels.forEach((label, index) => {
        const text = label.textContent.trim();
        // console.log(`Label ${index}: "${text}"`);
        // Extract English text (before the slash if bilingual)
        const englishText = text.split('/')[0].trim();
        if (translations[englishText]) {
          // console.log(`Translating "${englishText}" to "${translations[englishText]}"`);
          label.textContent = translations[englishText];
        }
      });
      
      // Translate legends
      const legends = document.querySelectorAll('legend');
      // console.log('Found', legends.length, 'legends');
      legends.forEach((legend, index) => {
        const text = legend.textContent.trim();
        // console.log(`Legend ${index}: "${text}" (class: ${legend.className})`);
        if (translations[text]) {
          // console.log(`Translating legend "${text}" to "${translations[text]}"`);
          legend.textContent = translations[text];
        } else {
          // console.log(`No translation found for legend: "${text}"`);
        }
      });
      
      // Also try more specific selectors for the form legends
      const formLegends = document.querySelectorAll('legend._textBody_2aowh_10');
      // console.log('Found', formLegends.length, 'form legends with specific class');
      formLegends.forEach((legend, index) => {
        const text = legend.textContent.trim();
        // console.log(`Form legend ${index}: "${text}"`);
        if (translations[text]) {
          // console.log(`Translating form legend "${text}" to "${translations[text]}"`);
          legend.textContent = translations[text];
        }
      });
      
      // Translate checkbox labels
      const checkboxLabels = document.querySelectorAll('label[class*="_checkboxField"] span');
      // console.log('Found', checkboxLabels.length, 'checkbox labels');
      checkboxLabels.forEach((span, index) => {
        const text = span.textContent.trim();
        // console.log(`Checkbox ${index}: "${text}"`);
        if (translations[text]) {
          // console.log(`Translating checkbox "${text}" to "${translations[text]}"`);
          span.textContent = translations[text];
        }
      });
      
      // Translate submit button
      const submitButton = document.querySelector('button[class*="_formSubmitButton"]');
      // console.log('Submit button found:', !!submitButton);
      if (submitButton) {
        const text = submitButton.textContent.trim();
        // console.log(`Submit button text: "${text}"`);
        const englishText = text.split('/')[0].trim();
        if (translations[englishText]) {
          // console.log(`Translating submit button "${englishText}" to "${translations[englishText]}"`);
          submitButton.textContent = translations[englishText];
        }
      }
      
      // Translate select placeholders
      const selectPlaceholders = document.querySelectorAll('span[class*="_formAddressRegionPlaceholder"]');
      // console.log('Found', selectPlaceholders.length, 'select placeholders');
      selectPlaceholders.forEach((placeholder, index) => {
        const text = placeholder.textContent.trim();
        // console.log(`Placeholder ${index}: "${text}"`);
        if (translations[text]) {
          // console.log(`Translating placeholder "${text}" to "${translations[text]}"`);
          placeholder.textContent = translations[text];
        }
      });
      
      // console.log('Translation attempt completed');
    }
    
    // Run translation immediately if form is already loaded
    translateFormElements();
    
    // Wait for the embedded form to load with more aggressive timing
    const intervals = [500, 1000, 2000, 3000, 4000, 5000, 7000, 10000];
    intervals.forEach(delay => {
      setTimeout(translateFormElements, delay);
    });
    
    // Also check every 2 seconds for the first 30 seconds
    const checkInterval = setInterval(() => {
      const hasFormElements = document.querySelectorAll('form[data-testid="form"]').length > 0;
      // console.log('Checking for form elements:', hasFormElements);
      
      if (hasFormElements) {
        // console.log('Form found! Running translation...');
        translateFormElements();
      }
    }, 2000);
    
    // Stop checking after 30 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
      // console.log('Stopped checking for form elements');
    }, 30000);
    
    // Also watch for form changes with MutationObserver
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Check if new nodes contain form elements
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const hasForm = node.querySelector && node.querySelector('form[data-testid="form"]');
              if (hasForm) {
                // console.log('Form detected via mutation observer!');
                setTimeout(translateFormElements, 100);
              }
            }
          });
        }
      });
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Wait for page to fully load before running translation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateFormToFrench);
  } else {
    translateFormToFrench();
  }

  // Modify Judge.me review text on mobile
  function updateJudgeMeTextOnMobile() {
    // Only run on mobile viewports
    if (window.innerWidth >= 768) {
      // On desktop, restore original display
      const badges = document.querySelectorAll('.jdgm-prev-badge');
      badges.forEach(badge => {
        badge.style.removeProperty('display');
      });
      return;
    }

    // Find the review text element
    const reviewTextElements = document.querySelectorAll('.jdgm-prev-badge__text');

    reviewTextElements.forEach(element => {
      const text = element.textContent.trim();
      // Match pattern like "24 reviews" or "1 review" (case insensitive)
      const match = text.match(/^(\d+)\s+reviews?$/i);

      if (match) {
        const count = match[1];
        element.textContent = `(${count})`;

        // Make the parent badge visible on mobile
        const badge = element.closest('.jdgm-prev-badge');
        if (badge) {
          badge.style.display = 'flex';
        }
      }
    });
  }

  // Run on page load with delay to ensure Judge.me has loaded
  function initJudgeMeUpdate() {
    updateJudgeMeTextOnMobile();
    // Also try again after a delay in case Judge.me loads slowly
    setTimeout(updateJudgeMeTextOnMobile, 500);
    setTimeout(updateJudgeMeTextOnMobile, 1000);
    setTimeout(updateJudgeMeTextOnMobile, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJudgeMeUpdate);
  } else {
    initJudgeMeUpdate();
  }

  // Re-run on window resize (if switching to/from mobile)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateJudgeMeTextOnMobile, 250);
  });

  // Watch for Judge.me content being dynamically added
  const judgeMeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if it's a Judge.me element
          if (node.className && typeof node.className === 'string' && node.className.includes('jdgm')) {
            setTimeout(updateJudgeMeTextOnMobile, 100);
          }
          // Or if it contains a Judge.me element
          if (node.querySelector && node.querySelector('[class*="jdgm"]')) {
            setTimeout(updateJudgeMeTextOnMobile, 100);
          }
        }
      });
    });
  });

  judgeMeObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// ==============================================
// Print Pattern Upsell
// ==============================================
// The card's "Add to order" button adds the print add-on — and the pattern
// too, unless it's already in the cart. Both line items are tagged with
// properties linking them (Pattern on the print, Print on the pattern)
// so fulfillment knows which pattern each print belongs to. Print quantity
// comes from the product's custom.pdf_page_count metafield, exposed on the
// card as data-print-quantity. Delegated so it survives section re-renders.
// ==============================================
(function() {
  // Serialise the main product form so the pattern line item keeps its variant,
  // quantity and any line item properties (e.g. Metres on fabric products).
  function buildPatternItem(form) {
    const data = new FormData(form);
    const id = data.get('id');
    if (!id) return null;

    const properties = {};
    data.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim() !== '') {
        properties[match[1]] = value;
      }
    });

    const item = {
      id: id,
      quantity: parseFloat(data.get('quantity')) || 1
    };

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    return item;
  }

  function setError(card, message) {
    const target = card.querySelector('[data-print-upsell-errors]');
    if (target) target.textContent = message || '';
  }

  // /cart/add.js and /cart/change.js return HTTP 200 with a status field on
  // soft errors, so every response goes through this check.
  function parseCartResponse(res) {
    return res.json().then(data => {
      if (data.status && data.status !== 200) {
        throw new Error(data.description || data.message || '');
      }
      return data;
    });
  }

  document.addEventListener('click', function(e) {
    const button = e.target.closest('[data-print-upsell-add]');
    if (!button) return;

    const card = button.closest('[data-print-upsell]');
    if (!card) return;

    e.preventDefault();
    setError(card, '');

    const printVariantId = card.dataset.printVariantId;
    const printQuantity = parseInt(card.dataset.printQuantity, 10) || 1;
    const patternTitle = card.dataset.patternTitle;
    const patternHandle = card.dataset.patternHandle;
    const form = document.getElementById(card.dataset.productFormId);
    if (!printVariantId || !form) return;

    const patternItem = buildPatternItem(form);
    if (!patternItem) return;

    button.classList.add('is-loading');
    button.disabled = true;

    fetch('/cart.js')
      .then(parseCartResponse)
      .then(cartData => {
        const items = cartData.items || [];

        // In /cart.js, item.id is the variant id. Prefer an untagged pattern
        // line so we know it still needs the Print flag.
        const patternLines = items.filter(item => String(item.id) === String(patternItem.id));
        const patternLine = patternLines.find(item => !(item.properties && item.properties['Print'])) || patternLines[0];

        const printProperties = {
          'Pattern': patternTitle,
          '_pattern_handle': patternHandle
        };

        // Identical variant + properties would stack quantities on one line;
        // a differing _copy value forces each re-click onto its own line.
        const existingPrints = items.filter(item =>
          String(item.id) === String(printVariantId) &&
          item.properties && item.properties['_pattern_handle'] === patternHandle
        ).length;
        if (existingPrints > 0) {
          printProperties['_copy'] = String(existingPrints + 1);
        }

        const itemsToAdd = [];
        if (!patternLine) {
          patternItem.properties = Object.assign({}, patternItem.properties, { 'Print': 'Yes' });
          itemsToAdd.push(patternItem);
        }
        itemsToAdd.push({ id: printVariantId, quantity: printQuantity, properties: printProperties });

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        })
          .then(parseCartResponse)
          .then(() => {
            if (!patternLine || (patternLine.properties && patternLine.properties['Print'])) return;

            // Tag the pattern line that was already in the cart. change.js
            // replaces the whole properties object, so merge the existing ones.
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: patternLine.key,
                quantity: patternLine.quantity,
                properties: Object.assign({}, patternLine.properties, { 'Print': 'Yes' })
              })
            })
              .then(parseCartResponse)
              .catch(error => {
                // The print is already in the cart at this point — surface the
                // tagging failure without treating the add as failed.
                console.error('Print upsell: failed to tag pattern line', error);
              });
          });
      })
      .then(() => {
        if (window.cart && typeof window.cart.getCart === 'function') {
          window.cart.getCart();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true }));
        }
      })
      .catch(error => {
        console.error('Print upsell: failed to add to cart', error);
        setError(card, error.message);
      })
      .finally(() => {
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  });
})();